import MockEntityObjectCreator from '@/testing/MockEntityObjectCreator';
import { ApiManager, GameOrganizer } from '@/utils';
import EventModifier from '@/utils/EventModifier';
import { LitElement, css, html } from "lit";
import { customElement, state } from "lit/decorators.js";
import { createAppRouter } from './router';

@customElement("host-app")
export class App extends LitElement {
	static styles = css`
        :host {
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 24px;
        }
    `;

	private readonly eventDataSource = new ApiManager();
	private readonly gameOrganizer = new GameOrganizer();
	private readonly mockEntityObjectCreator = new MockEntityObjectCreator();
	private readonly eventModifier = new EventModifier(this.eventDataSource, this.gameOrganizer, this.mockEntityObjectCreator);

	@state() private content = html`<div>Loading...</div>`;

	private router = createAppRouter({
		eventDataSource: this.eventDataSource,
		gameOrganizer: this.gameOrganizer,
		eventModifier: this.eventModifier,
	});

	connectedCallback() {
		super.connectedCallback();
		window.addEventListener('popstate', () => this.route());
		this.route();
	}

	async route() {
		// Normalize paths served under /static/ in dev or production builds
		let pathname = location.pathname;
		if (pathname.startsWith('/static')) {
			// remove the leading /static prefix but keep leading slash
			pathname = pathname.replace(/^\/static/, '') || '/';
		}
		const result = await this.router.resolve(pathname);

		if (result?.redirect) {
			const state = { from: result.from || location.pathname };
			window.history.pushState(state, '', result.redirect);
			window.dispatchEvent(new PopStateEvent('popstate'));
			return;
		}

		this.content = result?.content ?? result;
	}


	render() {
		return html`${this.content}<user-message-box></user-message-box>`;
	}
}
